module.exports = __webpack_public_path__ + "img/code.f2dbc814.jpeg";